module.exports = __webpack_public_path__ + "static/img/lunbo9.4f300ce4.webp";